import axios from "axios";
import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import {Link, useParams} from 'react-router-dom';
import RecentBlog from "../component/RecentBlog";
import { useSettings } from '../SettingsContext';
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

const BlogDetails = () => {
    const setting = useSettings();
    const { slug } = useParams();
    const [blog,setBlog] = useState([]);
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOG_DETAILS;
        axios.get(`${apiBaseUrl}${Url}/${slug}`)
            .then(response => setBlog(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[slug]);

    const [visaTypes,setVisaTypes] = useState([]);
    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setVisaTypes(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[]);

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | {blog?.title}</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/blog/details/${blog?.slug}`}/>
            </Helmet>
            <main className="main">
                <div className="blog-single pt-60">
                    <div className="container">
                        <div className="row g-4">
                            <div className="col-lg-8">
                                <div className="blog-single-wrap">
                                    <div className="blog-single-content">
                                        <div className="blog-thumb-img pb-5">
                                            <img style={{ width:"100%" }} src={`${backendBaseUrl}${blog?.image}`} alt="Thumb" />
                                        </div>
                                        <div className="blog-info">
                                            <div className="blog-details">
                                                <h4 className="blog-details-title mb-20">{blog?.title}</h4>
                                                <div className="site-heading mb-20" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog?.long_description) }}>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <aside className="blog-sidebar">
                                    <div className="widget category">
                                        <h5 className="widget-title fw-bold">VISA TYPES </h5>
                                        <div className="">
                                            <ul>
                                                {visaTypes.map((visaType, index) => {
                                                    return (
                                                        <li><Link className={'text-decoration-none text-dark'} to={`/visa/${visaType.slug}`}><i className="far fa-arrow-right"></i> {visaType?.name}</Link></li>
                                                    );
                                                })}

                                            </ul>

                                        </div>
                                    </div>
                                    <RecentBlog />
                                    <div className="widget social">
                                        <h5 className="widget-title">Follow Us</h5>
                                        <div className="social-link d-flex align-items-center gap-3">
                                            {[
                                                { key: 'facebook', icon: 'fab fa-facebook-f', label: 'Facebook', bg: '#1877F2' },
                                                { key: 'youtube', icon: 'fab fa-youtube', label: 'YouTube', bg: '#FF0000' },
                                                { key: 'instagram', icon: 'fab fa-instagram', label: 'Instagram', bg: '#E4405F' },
                                                { key: 'linkedIn', icon: 'fab fa-linkedin-in', label: 'LinkedIn', bg: '#0A66C2' },
                                                { key: 'tiktok', icon: 'fab fa-tiktok', label: 'TikTok', bg: '#000000' },
                                                { key: 'twitter', icon: 'fab fa-twitter', label: 'Twitter / X', bg: '#000000' },
                                            ].map((item) => (
                                                setting?.[item.key] && (
                                                    <a
                                                        key={item.key}
                                                        href={setting[item.key]}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label={item.label}
                                                        className="d-inline-flex align-items-center justify-content-center text-decoration-none shadow-sm"
                                                        style={{
                                                            width: '38px',
                                                            height: '38px',
                                                            borderRadius: '50%',
                                                            backgroundColor: item.bg,
                                                            color: '#ffffff',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        <i className={item.icon}></i>
                                                    </a>
                                                )
                                            ))}
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </>


    );
}

export default BlogDetails;